interface HasName {
    name: string;
}

const AccountNameComparator = (a: HasName, b: HasName): number => a.name.localeCompare(b.name);

export default AccountNameComparator;
